<template>
  <div class="wrap">
    <Row class="header">
      <Col span="8">
      <div class="logo-box"></div>
      <!--                <img class="logo" src="@/assets/images/logo.png">-->
      </Col>
      <Col
        class="menu"
        span="16"
      >
      <!--                <router-link class="router-item" to="index">工作台</router-link>-->
      <!--                <router-link class="router-item" to="">控制台</router-link>-->
      <!--                <router-link class="router-item" to="/developerCenter/index">开发者中心</router-link>-->
      </Col>
    </Row>
    <Row class="content">
      <Col span="12">
      <div class="login-bg-box">
        <img
          class="login-bg"
          src="@/assets/images/login-bg.png"
        >
      </div>
      </Col>
      <Col
        span="12"
        class="form"
      >
      <div class="login-type-box">
        <span
          class="login-type"
          :class="{active:loginType==1}"
          @click="loginType=1"
        >密码登录</span>
        <span class="line"></span>
        <span
          class="login-type"
          :class="{active:loginType==2}"
          @click="loginType=2"
        >短信登录</span>
      </div>
      <Form
        ref="form"
        :model="params"
      >
        <FormItem
          v-for="(item,index) in formItems"
          :key="index+item.prop"
          :prop="item.prop"
          :rules="item.rules||[]"
        >
          <Row
            v-if="item.prop == 'smsCode'"
            class="verify-code-box"
          >
            <Col span="3"> <i
              class="iconfont icon-iconfont-5"
              style="font-size: 26px; padding-left: 8px;"
            ></i></Col>
            <Col span="14">
            <Input
              v-model="params[item.prop]"
              v-bind="item"
              clearable
              v-on="item.on"
            >
            </Input>
            </Col>
            <Col
              span="7"
              style="text-align: right;"
            >
            <Button
              v-if="time<=0"
              class="send-code-btn"
              type="text"
              :disabled="!params.slider|| !params.loginPhone"
              @click="sendCode"
            >
              发送验证码
            </Button>
            <MyCountDown
              v-if="time>0"
              :time="time"
              format="ss 秒"
              @finish="time=0"
            />
            </Col>
          </Row>

          <MyFormItemField
            v-else
            v-model="params[item.prop]"
            :class="item.class"
            :type="item.type"
            v-bind="item"
            v-on="item.on"
          >
          </MyFormItemField>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            :loading="loading"
            long
            class="login-btn"
            @click="handleSubmit()"
          >
            登录
          </Button>
          <div class="form-bottom">
            <!--                            <span class="form-bottom-btn">忘记密码</span>-->
            <!--                            <span class="line"></span>-->
            <!-- <span
              class="form-bottom-btn"
              @click="$router.push('/register')"
            >免费注册</span> -->
          </div>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <div class="footer">
      <p>地址：中国浙江杭州西湖区文三路支付90号东部软件园6号楼6层</p>
      <p>浙江深大智能科技有限公司 版权所有 2008-2020</p>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5';
import MyCountDown from '@/components/CountDown/index';

export default {
  components: { MyCountDown },
  data() {
    return {
      time: 0,
      loginType: 1,
      formItems: [],
      userFormItems: [
        {
          prop: 'phone',
          type: 'text',
          prependIcon: 'ios-phone-portrait',
          placeholder: '请输入手机号',
          class: 'form-input',
          rules: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { required: true, validator: this.common.validate.phone, trigger: 'blur' },
          ],
        },
        {
          prop: 'accPwd',
          rules: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            // { min: 6, max: 12, message: '密码仅支持6-12位', trigger: 'blur' },
          ],
          type: 'render',
          render: (h) => {
            const html = [];
            // 图标
            const icon = h('icon', {
              style: {
                paddingLeft: '8px',
              },
              props: {
                type: 'ios-lock-outline',
                size: '26',
              },
            });
            html.push(icon);
            // 输入框
            const input = h('Input', {
              class: 'form-input',
              style: {
                width: '70%',
                marginLeft: '10px',
                marginRight: '10px',
              },
              props: {
                type: 'password',
                clearable: true,
                value: this.params.accPwd,
                placeholder: '请输入密码',
              },
              on: {
                input: (accPwd) => {
                  this.params.accPwd = accPwd;
                },
              },
            });
            html.push(input);
            // 忘记密码
            const span = h('span', {
              style: {
                color: '#5e7ce0',
                display: 'inline-block',
                // verticalAlign: 'middle',
                cursor: 'pointer',
                // paddingTop: '4px',
              },
              on: {
                click: () => {
                  this.$router.push('/forgetPass');
                },
              },
            }, '忘记密码');
            html.push(span);

            return html;
          },
        },
        {
          prop: 'verifyCode',
          type: 'render',
          placeholder: '请输入图形验证码',
          rules: [
            { required: true, message: '请输入图形验证码', trigger: 'blur' },
          ],
          render: (h) => {
            const html = [];
            // 图标
            const icon = h('i', {
              class: 'iconfont icon-iconfont-5',
              style: {
                fontSize: '26px',
                paddingLeft: '8px',
              },
            });
            html.push(icon);
            // 输入框
            const input = h('Input', {
              class: 'form-input',
              style: {
                width: '55%',
                marginLeft: '10px',
              },
              props: {
                clearable: true,
                value: this.params.verifyCode,
                placeholder: '请输入图形验证码',
              },
              on: {
                input: (verifyCode) => {
                  this.params.verifyCode = verifyCode;
                },
              },
            });
            html.push(input);
            // 图片
            const img = h('img', {
              style: {
                height: '24px',
                // verticalAlign: 'middle',
                margin: '0 3px',
              },
              attrs: {
                src: this.codeImg,
              },
              on: {
                click: this.getVerifyCode,
              },
            });
            html.push(img);
            // 换一换
            const span = h('span', {
              style: {
                color: '#5e7ce0',
                display: 'inline-block',
                // verticalAlign: 'middle',
                cursor: 'pointer',
                // paddingTop: '4px',
              },
              on: {
                click: this.getVerifyCode,
              },
            }, '换一换');
            html.push(span);

            return html;
          },
        },
      ],
      smsFormItems: [
        {
          prop: 'loginPhone',
          prependIcon: 'ios-phone-portrait',
          type: 'text',
          placeholder: '请输入手机号',
          class: 'form-input',
          rules: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { required: true, validator: this.common.validate.phone, trigger: 'blur' },
          ],
        },
        {
          prop: 'slider',
          type: 'slider',
          // rules: [
          //     {
          // required: true,
          // validator: (rule, value, callback) => {
          //     if (value !== true) {
          //         callback(new Error('拖动滑块到最右边'))
          //         return
          //     } else {
          //         callback()
          //     }
          // },
          // trigger: "change"
          // }
          // ],
        },
        {
          prop: 'smsCode',
          type: 'text',
          placeholder: '请输入短信验证码',
          rules: [
            { required: true,
              validator: (rule, value, callback) => {
                if (!rule.required && !value) {
                // 非必填时
                  callback();
                  return;
                }
                const { key } = this.params;
                if (!key) {
                  callback(new Error('请先获取短信验证码！'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
            { required: true, message: '请输入短信验证码', trigger: 'blur' },
          ],
        },
      ],
      params: {
        // user: '',
        // password: '',
        appId: 'payCenterAdmin',
        phone: '',
        accPwd: '',
        verifyCode: '',
        verifyCodeKey: '',
        slider: false,
      },
      codeImg: '',
      loading: false,
    };
  },
  watch: {
    loginType: {
      handler(newVal) {
        this.params.slider = false;
        if (Number(newVal) === 1) {
          this.formItems = [...this.userFormItems];
        } else {
          this.formItems = [...this.smsFormItems];
        }
      },
      immediate: true,
    },
  },
 
 
  created() {
    this.getVerifyCode();
    document.onkeydown = () => {
      if (window.event.keyCode === 13) {
        this.handleSubmit();
      }
    };
  },
  methods: {
    // 获取图片验证码
    getVerifyCode() {
      this.params.verifyCodeKey = new Date().getTime();
      this.codeImg = this.pathRewrite(`/api/user/verifyCode?verifyCodeKey=${ this.params.verifyCodeKey}`);
    },
    // 登录
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url = '/api/user/login';
          const { accPwd, appId, phone, verifyCode, verifyCodeKey } = this.params;
          let params = { accPwd: md5(accPwd.trim()), appId, phone, verifyCode, verifyCodeKey };
          if (Number(this.loginType) === 2) {
            url = '/api/user/login/phone';
            const { key, loginPhone, smsCode } = this.params;
            if (!key) {
              this.$Message.warning('短信验证码不正确');
              return;
            }
            params = { appId, key, loginPhone, smsCode };
          }
          this.loading = true;
          this.$http.post(url, this.common.utils.trim(params)).then(res => {
            this.loading = false;
            if (Number(this.loginType) === 2) {
              this.params.slider = false;
            } else {
              this.getVerifyCode();
            }
            if (res.success) {
              this.$store.commit('setUserInfo',res.data);
              this.$router.push('/');
              // 根据权限生成菜单及路由
              // const menuRoutes = addRoutes(res.data.privilegeList);
              // 判断是否完善信息
              // if (Number(res.data.infoFlag) === 0) {
              //   if (menuRoutes.length) {
              //     this.$router.push(menuRoutes[0].path);
              //   } else {
              //     this.$Message.error('无访问权限');
              //   }
              //   // this.$router.push('/index');
              // } else {
              //   this.$router.push('/supplyInfo');
              // }
            } else {
              this.$Message.warning(res.message || '请求出错');
            }
          });
        }
      });
    },
    // 发送短信
    sendCode() {
      const url = '/api/user/getSmsCode';
      const { appId, loginPhone } = this.params;
      const params = {
        appId,
        phone: loginPhone,
        type: 0, // 0-登录 1-注册验证码 2-重置密码 3-找回密码
      };
      this.$http.post(url, this.common.utils.trim(params)).then(res => {
        if (res.success) {
          this.time = 60000;
          this.params.key = res.data.key;
          this.$Message.success('短信发送成功');
        } else {
          this.params.slider = false;
          this.$Message.warning(res.message || '短信发送失败');
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
    .line {
      display: inline-block;
      height: 18px;
      margin: 0 10px;
      border-right: 1px solid #999;
      vertical-align: middle;
    }
    .header {
      padding: 20px 40px 5px;
      // border-bottom: 1px solid #e5e5e5;
      .logo-box {
        height: 50px;
      }
      .logo {
        width: 160px;
      }
      .menu {
        text-align: right;
        line-height: 40px;
        .router-item {
          color: #999;
          display: inline-block;
          margin: 0 20px;
        }
      }
    }
    .login-bg-box {
      text-align: right;
      padding-right: 40px;
      .login-bg {
        width: 530px;
      }
    }
    .content {
      padding-top: 120px;
    }
    .form {
      box-sizing: border-box;
      padding: 10px 20px;

      /* margin-top: 150px; */
      width: 380px;

      /* background-color: rgba(0,0,0,.5); */
      border-radius: 10px;

      /* border: 1px solid #e7e7e7; */
      box-shadow: 0 0 10px 1px #e7e7e7;
      /deep/ .ivu-form-item-error-tip {
        left: 50px;
      }
      /deep/ .ivu-input {
        font-size: 14px;
        border: 0;
        border-bottom: 1px solid #ddd;
      }
      .login-btn {
        margin-top: 10px;
        font-size: 14px;
        height: 40px;
        background-color: #256af7;
        border-color: #256af7;
      }
      .send-code-btn {
        color: #256af7;
        &[disabled] {
          color: #c5c8ce;
          background-color: #fff;
          border-color: transparent;
        }
      }
      /deep/ .form-input {
        // border-bottom: 1px solid #ddd;
        padding-bottom: 5px;
        /deep/ .ivu-input-group-prepend {
          border: 0;
          background-color: transparent;
        }
        /deep/ .ivu-input {
          // border: 0;
          background-color: transparent !important;
          &:focus {
            box-shadow: 0 0 0 0;
          }
        }
        /deep/ .ivu-input-group-prepend .ivu-icon {
          font-size: 28px;
        }
      }
      /deep/ .ivu-form-item:first-child .form-input {
        border-color: #256af7;
      }
      .verify-code-box {
        // border-bottom: 1px solid #ddd;
        padding-bottom: 5px;
        /deep/ .ivu-input {
          // border: 0;
          background-color: transparent !important;
          &:focus {
            box-shadow: 0 0 0 0;
          }
        }
      }
    }
    .login-type-box {
      padding: 10px 12px;
      .login-type {
        cursor: pointer;
        display: inline-block;

        /* width: 46%; */

        /* text-align: center; */

        /* background-color: #ccc; */
        padding: 5px 0;
        border-radius: 5px;
        font-size: 14px;
        vertical-align: middle;
      }
      .login-type.active {
        color: #3e76f8;
      }
    }
    .form-bottom {
      text-align: center;
      .form-bottom-btn {
        display: inline-block;
        cursor: pointer;
        color: #3e76f8;
        font-size: 13px;
      }
      .line {
        height: 13px;
      }
    }
    .footer {
      /* position: fixed; */

      /* bottom: 30px; */

      /* width: 100%; */
      margin: 100px 0 30px 0;
      text-align: center;
      color: #999;
      font-size: 13px;
      line-height: 2;
    }
</style>
